export class Navigation
{
	buttons = document.querySelectorAll('[data-s~="Navigation:goto"]')

    constructor(store)
    {
        this.store = store
    }

    goto(e)
    {
        if (window.innerWidth > 1000) {
            window.location.href = "#button-navigation-mainpage"
        } else if (window.innerWidth <= 1000) {
            this.store.service.Modal.target = "navigation"
            this.store.service.Modal.show()
        }
    }

	watch()
	{
        this.buttons.forEach(e => {
			e.addEventListener("click", () => {
                this.goto()
            })
		})
	}
}
